// Internal guest roles the registration crew is alerted about. Guests never see these.
export const ROLES = {
  award: {
    label: "Award recipient",
    short: "award",
    tag: "border-[#ffc83d]/50 text-[#ffc83d]",
    panel: "border-[#ffc83d] bg-[#ffc83d]/10 text-[#ffc83d]",
    heading: "text-[#ffc83d]",
  },
  vip: {
    label: "VIP",
    short: "VIP",
    tag: "border-[#c084fc]/50 text-[#c084fc]",
    panel: "border-[#c084fc] bg-[#c084fc]/10 text-[#c084fc]",
    heading: "text-[#c084fc]",
  },
  table_ic: {
    label: "Table-IC",
    short: "table-IC",
    tag: "border-[#38bdf8]/50 text-[#38bdf8]",
    panel: "border-[#38bdf8] bg-[#38bdf8]/10 text-[#38bdf8]",
    heading: "text-[#38bdf8]",
  },
};

export const roleOf = (r) =>
  ROLES[r?.guest_role] || (r?.award_recipient ? ROLES.award : null);
